import React from 'react';
import PropTypes from 'prop-types';
import { InputControl } from '@si-armes/dsfr-react';
import InputFiles from '../../../../../components/Commun/Form/InputFiles';
import BoutonTelechargementFichier from '../../../../../components/BoutonTelechargementFichier/BoutonTelechargementFichier';

const InputsLicencie = ({
    selectLicencieOrAncienLicencie,
    licenceExist,
    isAncienLicencie,
    numeroLicence,
    labelInputMi,
    licenceFichierName,
    register,
    licence,
    fileUploaded,
    labelTelechargement,
}) => {
    let inputs;

    if (selectLicencieOrAncienLicencie === 'isLicencie') {
        if ((licenceExist && isAncienLicencie) || !licenceExist) {
            inputs = (
                <>
                    <InputControl
                        name={numeroLicence}
                        label={labelInputMi}
                        {...register(numeroLicence)}
                        required
                    />

                    {licenceFichierName && (
                        <InputFiles
                            name={licenceFichierName}
                            label="Importer la licence"
                            required
                            licenceFichier={fileUploaded ? [fileUploaded] : []}
                        />
                    )}
                </>
            );
        } else if (licenceExist && !isAncienLicencie) {
            inputs = (
                <>
                    <InputControl
                        id={numeroLicence}
                        name={numeroLicence}
                        label={labelInputMi}
                        disabled
                        value={licence?.numero}
                    />

                    {licenceFichierName && licence?.licenceFichier?.filename && (
                        <BoutonTelechargementFichier
                            libelle={licence?.licenceFichier.filename}
                            uuidFichier={licence?.licenceFichier.uuid}
                            id={`fichier_${licence?.licenceFichier.filename}`}
                            aria-label={labelTelechargement}
                        />
                    )}
                </>
            );
        }
    } else if (selectLicencieOrAncienLicencie === 'isAncienLicencie') {
        if ((licenceExist && !isAncienLicencie) || !licenceExist) {
            inputs = (
                <>
                    <InputControl
                        id={numeroLicence}
                        name={numeroLicence}
                        label={labelInputMi}
                        {...register(numeroLicence)}
                    />

                    {licenceFichierName && (
                        <InputFiles
                            name={licenceFichierName}
                            label="Importer la licence"
                            licenceFichier={fileUploaded ? [fileUploaded] : []}
                        />
                    )}
                </>
            );
        } else if (licenceExist && isAncienLicencie) {
            inputs = (
                <>
                    {licence?.numero && (
                        <InputControl
                            id={numeroLicence}
                            name={numeroLicence}
                            label={labelInputMi}
                            value={licence.numero}
                            disabled
                        />
                    )}

                    {licenceFichierName && licence?.licenceFichier?.filename && (
                        <BoutonTelechargementFichier
                            libelle={licence?.licenceFichier?.filename}
                            uuidFichier={licence?.licenceFichier.uuid}
                            id={`fichier_${licence?.licenceFichier?.filename}`}
                            aria-label={labelTelechargement}
                        />
                    )}
                </>
            );
        }
    }

    return inputs;
};

InputsLicencie.propTypes = {
    selectLicencieOrAncienLicencie: PropTypes.string,
    licenceExist: PropTypes.bool,
    isAncienLicencie: PropTypes.bool,
    numeroLicence: PropTypes.string,
    labelInputMi: PropTypes.string,
    licenceFichierName: PropTypes.string,
    labelTelechargement: PropTypes.string,
    register: PropTypes.func,
    licence: PropTypes.object,
};

export default InputsLicencie;
